<template>
  <div id="home">
    <div id="navbar" class="navbar navbar-default navbar-fixed-top" role="navigation">
        <div class="container-fluid">
            <div class="navbar-home-left">
                <div v-show="user.data.login">
                    <a :href="user.data.html_url" target="spcae">
                        <img :src="user.data.avatarUrl" style="height:25px;" />
                        <a class="navbar-text-hide">&nbsp; Hey,
                            <b>{{ user.data.login }}</b>!</a>
                    </a>
                </div>
            </div>
            <div class="nav navbar-home-right">
                <a v-show="user.data.login" href="/logout" target="_self" class="octicon octicon-sign-out" style="font-size:19px" tooltip-placement="left"
                    tooltip="Sign out"></a>
            </div>
            <div class="navbar-center">
                <a href="https://opensource.tencent.com" style="display: block;margin-left: auto;margin-right: auto;width:  156px;">
                    <img class="center-block img-responsive" src="/static/images/logo_opensource_black.png">
                </a>
            </div>
        </div>
    </div>

    <div class="container-fluid ui-view-content">
        <div style="margin-left:15px; margin-right: 15px">
            <section class="col-md-8 col-md-offset-2">
                <router-view></router-view>
            </section>
        </div>
    </div>

    <div class="footer">
        <div class="footer__contact">
            <div class="footer__contact-weixin">
                微信公众号
            <div class="footer__contact-weixin-qrcode"></div>
            </div>
            <a href="mailto:tencentopen@tencent.com" title="腾讯开源联系我们" class="footer__contact-email">Email</a>
        </div>
        <p style="color:#bbb; text-align: center">Copyright © 1998 - 2018 Tencent. All Rights Reserved.</p>
        <p style="color:#bbb; text-align: center">腾讯公司版权所有</p>
    </div>
  </div>
</template>

<script>
import {getUserFromGithub, checkAdmin} from '@/api/home'
export default {
  name: 'home',
  data() {
    return {
      user: {
        data:{
          login:'',
          html_url:''
        }
      }
    }
  },
  created() {
    this.getUser()
  },
  methods:{
    getUser() {
        return getUserFromGithub().then((res) =>{
            if (res) {
                this.user = res;
            }
        })
    },
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/javascript/home/components/home.vue